import React from 'react'

const Announcements = () => {
  return (
    <div className='w-full h-full bg-yellow-500'>Announcements</div>
  )
}

export default Announcements